export const aboutAssets = {
  about: {
    main: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/about/about.webp`,
    company: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/aboutcompany.webp`,
    second: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/about/about-2.webp`,
    third: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/about/about-3.webp`,
    hero: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/about-hero.webp`,
    heroBg: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/about-hero-bg.webp`,
  },
  aboutBrands: {
    brand1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/about/brand-1.webp`,
    brand2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/about/brand-2.webp`,
    brand3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/about/brand-3.webp`,
    brand4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/about/brand-4.webp`,
    brand5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/about/brand-5.webp`,
    brand6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/about/brand-6.webp`,
  },
};
